import React from "react"
import { Checkbox, Dropdown, Form, Header, Input } from "semantic-ui-react"
import ArrayToUiList from "../../helpers/ArrayToUIList"
import { save } from "../../store/reducers/GooglePayInputData"
import { useAppDispatch, useAppSelector } from "../../store/hooks"
import { RootState } from "../../store/SrciStore"

export default function GooglePay(this: any) {
  const totalPriceStatus = ArrayToUiList(["NOT_CURRENTLY_KNOWN", "ESTIMATED", "FINAL"])
  const paymentMethodType = ArrayToUiList(["CARD", "PAYPAL"])
  const allowedCardAuthMethods = ArrayToUiList(["PAN_ONLY", "CRYPTOGRAM_3DS"])
  const allowedCardNetworks = ArrayToUiList([
    "AMEX",
    "DISCOVER",
    "ELECTRON",
    "ELO",
    "ELO_DEBIT",
    "INTERAC",
    "JCB",
    "MAESTRO",
    "MASTERCARD",
    "VISA",
  ])
  const allowedCountryCodes = ArrayToUiList(["PL", "SE"])
  const buttonColor = [
    { value: "default", text: "DEFAULT", key: "DEFAULT" },
    { value: "black", text: "BLACK", key: "BLACK" },
    { value: "white", text: "WHITE", key: "WHITE" },
  ]

  const googlePayInitParams = useAppSelector((state: RootState) => state.googlepayInputData.googlePayInitParams)
  const googlePayButtonParams = useAppSelector((state: RootState) => state.googlepayInputData.googlePayButtonParams)
  const dispatch = useAppDispatch()

  const handleOnChange = (e: any, element: any) => {
    if (element.type === "checkbox") {
      element.value = element.checked
    }

    dispatch(
      save({
        name: element.name,
        value: element.value,
      })
    )
  }

  return (
    <React.Fragment>
      <Form>
        <Header as="h2">Google Pay Inputs</Header>
        <Form.Group widths="equal">
          <Form.Select
            fluid
            label="Total Price Status"
            options={totalPriceStatus}
            defaultValue={googlePayInitParams.totalPriceStatus}
            name="googlePayInitParams.totalPriceStatus"
            onChange={handleOnChange}
          />
          <Form.Select
            fluid
            label="Payment Method Type"
            options={paymentMethodType}
            defaultValue={googlePayInitParams.paymentMethodType}
            name="googlePayInitParams.paymentMethodType"
            onChange={handleOnChange}
          />
          <Form.Field>
            <label>Gateway Merchant Id</label>
            <Input
              value={googlePayInitParams.gatewayMerchantId}
              name="googlePayInitParams.gatewayMerchantId"
              onChange={handleOnChange}
            />
          </Form.Field>
          <Form.Field>
            <label>Gateway</label>
            <Input value={googlePayInitParams.gateway} name="googlePayInitParams.gateway" onChange={handleOnChange} />
          </Form.Field>
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Field>
            <label>Allowed Card Auth Methods</label>
            <Dropdown
              fluid
              multiple
              selection
              options={allowedCardAuthMethods}
              defaultValue={googlePayInitParams.allowedCardAuthMethods}
              name="googlePayInitParams.allowedCardAuthMethods"
              onChange={handleOnChange}
            />
          </Form.Field>
          <Form.Field>
            <label>Allowed Card Networks</label>
            <Dropdown
              fluid
              multiple
              selection
              options={allowedCardNetworks}
              defaultValue={googlePayInitParams.allowedCardNetworks}
              name="googlePayInitParams.allowedCardNetworks"
              onChange={handleOnChange}
            />
          </Form.Field>
        </Form.Group>

        <Form.Field>
          <Checkbox
            label="Enable Promo Codes"
            checked={googlePayInitParams.enablePromoCodes}
            name="googlePayInitParams.enablePromoCodes"
            onChange={handleOnChange}
          />
        </Form.Field>
        <Form.Field>
          <Checkbox
            label="Email Required"
            checked={googlePayInitParams.emailRequired}
            name="googlePayInitParams.emailRequired"
            onChange={handleOnChange}
          />
        </Form.Field>
        <Form.Field>
          <Checkbox
            label="Billing Address Required"
            checked={googlePayInitParams.billingAddressRequired}
            name="googlePayInitParams.billingAddressRequired"
            onChange={handleOnChange}
          />
        </Form.Field>

        <Header as="h2">Google Pay Button Inputs</Header>
        <Form.Group widths="equal">
          <Form.Select
            fluid
            label="Button Color"
            options={buttonColor}
            defaultValue={googlePayButtonParams.buttonColor}
            name="googlePayButtonParams.buttonColor"
            onChange={handleOnChange}
          />
        </Form.Group>

        <Header as="h2">Google Pay Shipping Inputs</Header>
        <Form.Group widths="equal">
          <Form.Field>
            <label>Allowed Country Codes</label>
            <Dropdown
              fluid
              multiple
              selection
              options={allowedCountryCodes}
              name="googlePayInitParams.shippingAddressParameters.allowedCountryCodes"
              defaultValue={googlePayInitParams.shippingAddressParameters?.allowedCountryCodes}
              onChange={handleOnChange}
            />
          </Form.Field>
          <Form.Field>
            <label>Default Selected Option ID</label>
            <Input 
              value={googlePayInitParams.shippingOptionParameters?.defaultSelectedOptionId} 
              name="googlePayInitParams.shippingOptionParameters.defaultSelectedOptionId" 
              onChange={handleOnChange} />
          </Form.Field>
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Field>
            <Checkbox
              label="Phone Number Required"
              checked={googlePayInitParams.shippingAddressParameters?.phoneNumberRequired}
              name="googlePayInitParams.shippingAddressParameters.phoneNumberRequired"
              onChange={handleOnChange}
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              label="Shipping Option Required"
              checked={googlePayInitParams.shippingOptionRequired}
              name="googlePayInitParams.shippingOptionRequired"
              onChange={handleOnChange}
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              label="Shipping Address Required"
              checked={googlePayInitParams.shippingAddressRequired}
              name="googlePayInitParams.shippingAddressRequired"
              onChange={handleOnChange}
            />
          </Form.Field>
        </Form.Group>
      </Form>
    </React.Fragment>
  )
}
